module.exports = __webpack_public_path__ + "static/media/fan2_lamp1.50c6bb14.gif";